module.exports = function getResource(label, vars = []) {
    let resources = {
        sortBy: 'Sort by'
    };

    return resources[label];
};
